function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.7708333,3.85416667 C72.7083333,-0.208333333 66.1458333,-0.208333333 62.0833333,3.85416667 L8.64583333,57.1875 C8.4375,57.3958333 8.33333333,57.5 8.22916667,57.7083333 C8.22916667,57.7083333 8.22916667,57.8125 8.125,57.8125 C8.02083333,58.0208333 7.91666667,58.125 7.91666667,58.3333333 C7.91666667,58.3333333 7.91666667,58.4375 7.91666667,58.4375 L0.833333333,81.5625 C0.520833333,82.7083333 0.833333333,83.8541667 1.5625,84.6875 C2.1875,85.3125 2.91666667,85.625 3.75,85.625 C4.0625,85.625 4.375,85.625 4.6875,85.5208333 L27.7083333,78.4375 C27.7083333,78.4375 27.8125,78.4375 27.8125,78.4375 C28.0208333,78.3333333 28.2291667,78.3333333 28.3333333,78.2291667 C28.3333333,78.2291667 28.4375,78.2291667 28.4375,78.125 C28.6458333,78.0208333 28.8541667,77.9166667 28.9583333,77.7083333 L82.2916667,24.375 C86.3541667,20.3125 86.3541667,13.75 82.2916667,9.6875 L76.7708333,3.85416667 Z M8.54166667,77.7083333 L12.3958333,65.3125 L21.0416667,73.9583333 L8.54166667,77.7083333 Z",
  transform: "translate(.292 .25)"
});

var SvgEditSmall = function SvgEditSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEditSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-small.7cd3d14d.svg";
export { ForwardRef as ReactComponent };